export const socialIcons = {
	"Facebook": "fab fa-facebook-square",
	"Instagram": "fab fa-instagram",
	"YouTube": "fab fa-youtube",
	"LinkedIn": "fab fa-linkedin",
	"Twitter": "fab fa-twitter-square",
	"WhatsApp": "fab fa-whatsapp-square",
	"WeChat": "fab fa-weixin",
	"Skype": "fab fa-skype",
	"Viber": "fab fa-viber",
	"Pinterest": "fab fa-pinterest-square",
	"Telegram": "fab fa-telegram",
	"ORCID": "fab fa-orcid",
	"Google Scholar": "fab fa-google",
	"ResearchGate": "fab fa-researchgate",
	"Scopus": "fa fa-book-open"
}



// WEBPACK FOOTER //
// ./src/functions.js